export default {
    getFileName(file) {
        var fileName = "iotm/Zips";
        if (file.type.indexOf("image") != -1)
            fileName = "iotm/Images";
        else if (file.type.indexOf("word") != -1)
            fileName = "iotm/Words";
        else if (file.type.indexOf("video") != -1)
            fileName = "iotm/Videos";
        let index = file.name.lastIndexOf(".");
        let ext = file.name.substr(index + 1).toLowerCase();
        var dt = this.getDate().replace('-', '/').replace('-', '/');
        return fileName + "/" + dt + "/" + "oss_" + this.getGuid() + "." + ext;

    },
    getGuid() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    },
    getDate() {
        let dt = new Date();
        let yy = dt.getFullYear();
        let mm = dt.getMonth() + 1;
        if (mm < 10)
            mm = '0' + mm;
        let dd = dt.getDate();
        if (dd < 10)
            dd = '0' + dd;
        return yy + "-" + mm + "-" + dd;
    },
    downLoad(url) {
        var downloadElement = document.createElement('a');
        downloadElement.style.display = "none";
        downloadElement.href = url;
        document.body.appendChild(downloadElement);
        downloadElement.click();
    },
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js